import React from 'react';

const LogoStrip = () => {
  return (
    <div className="logo-strip">
      <span>Parents</span>
      <span>The Bump</span>
      <span>Mother & Baby</span>
      <span>What to Expect</span>
      <span>BabyCenter</span>
    </div>
  );
};

export default LogoStrip;